/* dev-product-card.js
   Inline color-swatch -> image swap on fabric cards (collection grid + recommendations).

   Why one document-level listener: sections/dev-collection-grid.liquid rebuilds the
   whole grid via `productGrid.innerHTML = newGrid.innerHTML` on every filter/sort, so
   per-element listeners bound at load would die after the first filter. Event delegation
   on `document` plus data attributes on the freshly rendered swatches keeps working with
   no re-init.

   Each swatch <button> (snippets/dev-product-card.liquid) carries:
     data-card-swatch, data-variant-id, data-color-name,
     data-image (600w) + data-image-2x (900w)   [omitted when the variant has no image]
   The card root <div> carries data-product-card + data-product-url; the <img> carries data-card-img;
   the name <a class="dev-product-card__link"> is the card's one link (stretched via CSS).

   The swatch quick-add chip (data-dev-swatchchip) is NOT handled here: its memo
   resolver + "+" / "No swatch" / added state machine are assets/memo-chip.js,
   shared with the collection-products chip (theme#493). This file only tells it
   to re-decide after a colorway toggle.
*/
(function () {
  'use strict';
  if (window.__devCardSwatchInit) return; // guard: snippet's <script> is loaded by two sections
  window.__devCardSwatchInit = true;

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest ? e.target.closest('[data-card-swatch]') : null;
    if (!swatch) return;

    // The swatch sits inside the card's <a>, so a plain click would navigate to the PDP.
    // Cancel that -- the whole point is to change color WITHOUT opening the product page.
    e.preventDefault();

    var card = swatch.closest('[data-product-card]');
    if (!card) return;

    // Move the active state across this card's swatches only.
    var swatches = card.querySelectorAll('[data-card-swatch]');
    swatches.forEach(function (s) {
      var active = s === swatch;
      s.classList.toggle('dev-product-card__swatch--active', active);
      s.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    // Repoint the card link to the chosen colorway so a follow-up click lands on it.
    var base = card.getAttribute('data-product-url');
    var vid = swatch.getAttribute('data-variant-id');
    if (base && vid) {
      var href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'variant=' + vid;
      var link = card.tagName === 'A' ? card : (card.querySelector('.dev-product-card__link') || card.querySelector('a[href]'));
      if (link) link.setAttribute('href', href);
    }

    // Swap the displayed image -- only for colorways that actually have one. Metafield-only
    // swatches render as <span> without data-card-swatch and never reach here; a variant
    // lacking featured_image has no data-image and just updates active state + link.
    var url = swatch.getAttribute('data-image');
    var img = card.querySelector('[data-card-img]');
    if (img && img.tagName === 'IMG' && url) {
      var url2x = swatch.getAttribute('data-image-2x');
      // The card <img> ships a srcset; setting only src won't win against it. Mirror the
      // PDP: rebuild srcset (keeping the existing `sizes`), or drop srcset when there's no 2x.
      if (url2x) {
        img.srcset = url + ' 600w, ' + url2x + ' 900w';
      } else {
        img.removeAttribute('srcset');
      }
      img.src = url;
      var name = swatch.getAttribute('data-color-name');
      if (name) img.alt = name;
    }

    // The quick-add chip answers for the ACTIVE colorway: flip it back to "+"
    // (or to the honest "No swatch" word) for the one just chosen. The chip's
    // resolver + state machine live in assets/memo-chip.js (theme#493); it is
    // loaded alongside this file by every section that renders cards -- guard
    // the call so a missing module degrades to "no re-decide", never a throw.
    if (window.AsthetikMemo) window.AsthetikMemo.decideCard(card);
  });
})();
